import { createFileRoute, redirect } from '@tanstack/react-router';
import { isWeaveTokenActive, isWeaveTokenBufferActive } from '@frontend/auth-helpers';
import { SignInView } from '../../features/auth/components/sign-in-view';
import { useAuthStore } from '../../store/auth-store';

export const Route = createFileRoute('/_public/sign-in')({
  component: SignInView,
  beforeLoad: () => {
    // If already authenticated with valid ACLs, skip login page
    if (isWeaveTokenActive() || isWeaveTokenBufferActive()) {
      useAuthStore.getState().hydrate();
      const { hasRequiredAcl } = useAuthStore.getState();
      if (hasRequiredAcl) {
        throw redirect({ to: '/dashboard' });
      }
      // If authenticated but no ACL, let them see the login page (token is already cleared or they can re-login)
    }

    return undefined;
  },
});
